import { render, staticRenderFns } from "./TemplateCascade.vue?vue&type=template&id=5689cdf9"
import script from "./TemplateCascade.vue?vue&type=script&lang=js"
export * from "./TemplateCascade.vue?vue&type=script&lang=js"
import style0 from "./TemplateCascade.vue?vue&type=style&index=0&id=5689cdf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports